import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import { YodaColors } from 'yoda-ui/yodaTheme';

export const buttonStyle: SxProps<Theme> = {
  background: YodaColors.blue7,
  width: '48px',
  height: '48px',
  color: 'white',
  cursor: 'pointer',

  '&:hover, &:focus': {
    background: YodaColors.blue7,
  },
};
